import { einstandsKarte, flaschenPreis, gesamtFlaschen, jahrgangFuer, regionZuWein } from "../kern/fachlogik.js";


/* Kellerdaten je Region (mit Koordinaten) für die Weltkarte:
   Flaschen und Wert, getrennt nach Bestand und Getrunkenem. */
function kellerNachRegion(db, jahr = null) {
  const weinById = new Map(db.weine.map((w) => [w.id, w]));
  const agg = new Map();
  const hole = (region) => {
    if (!agg.has(region.id)) agg.set(region.id, { region, bestandFl: 0, bestandWert: 0, trinkFl: 0, trinkWert: 0 });
    return agg.get(region.id);
  };
  const jahrVon = (iso) => {
    if (!iso) return null;
    const d = new Date(iso);
    return Number.isNaN(d.getTime()) ? null : d.getFullYear();
  };
  const einstand = einstandsKarte(db);
  const regionVon = (w) => {
    const r = regionZuWein(db, w);
    return r && r.lat != null && r.lon != null ? r : null;
  };
  /* Ohne Jahr: heutiger Bestand. Mit Jahr: die Zugänge dieses Jahres —
     dieselbe Lesart wie in der übrigen Statistik. */
  if (jahr == null) {
    for (const w of db.weine) {
      const region = regionVon(w);
      if (!region) continue;
      for (const jg of w.jahrgaenge) {
        const fl = gesamtFlaschen(jg);
        if (fl <= 0) continue;
        /* Gleiche Preisregel wie in der Statistik: Jahrgangspreis,
           sonst Ø Kaufpreis aus den Zugängen. */
        const p = flaschenPreis(jg, einstand);
        const e = hole(region);
        e.bestandFl += fl;
        e.bestandWert += fl * (p != null ? p : 0);
      }
    }
  } else {
    for (const b of db.bewegungen || []) {
      if (b.art !== "zugang" || jahrVon(b.datum) !== jahr) continue;
      const w = weinById.get(b.weinId);
      if (!w) continue;
      const region = regionVon(w);
      if (!region) continue;
      const jg = jahrgangFuer(w, b.jgId, b.jahr);
      const preis = b.preis != null ? b.preis : (jg && jg.preis != null ? jg.preis : 0);
      const e = hole(region);
      e.bestandFl += b.menge || 0;
      e.bestandWert += (b.menge || 0) * preis;
    }
  }
  for (const en of db.entnahmen || []) {
    if (jahr != null && jahrVon(en.datum) !== jahr) continue;
    const w = weinById.get(en.weinId);
    if (!w) continue;
    const region = regionVon(w);
    if (!region) continue;
    const jg = jahrgangFuer(w, en.jgId, en.jahr);
    const preis = en.preis != null ? en.preis : (jg && jg.preis != null ? jg.preis : 0);
    const e = hole(region);
    e.trinkFl += en.menge || 0;
    e.trinkWert += (en.menge || 0) * preis;
  }
  return [...agg.values()];
}


/* Weltkarte (Länderumrisse) einmalig vom CDN laden und aus dem TopoJSON
   in projizierbare SVG-Pfade übersetzen — analog zum Nachladen von SheetJS. */
const WELTKARTE_CDN = "https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json";

let weltkarteCache = null;

let weltkartePromise = null;

function topoZuPfade(topo) {
  const obj = topo.objects.countries || topo.objects[Object.keys(topo.objects)[0]];
  const [sx, sy] = topo.transform.scale;
  const [tx, ty] = topo.transform.translate;
  const cache = {};
  const decodeArc = (idx) => {
    if (cache[idx]) return cache[idx];
    let x = 0, y = 0; const pts = [];
    for (const d of topo.arcs[idx]) { x += d[0]; y += d[1]; pts.push([x * sx + tx, y * sy + ty]); }
    cache[idx] = pts; return pts;
  };
  const arc = (i) => { const rev = i < 0; const a = decodeArc(rev ? ~i : i); return rev ? a.slice().reverse() : a; };
  const ringPfad = (ringArcs) => {
    const punkte = [];
    for (const ai of ringArcs) {
      const seg = arc(ai);
      for (let k = 0; k < seg.length; k++) { if (k === 0 && punkte.length) continue; punkte.push(seg[k]); }
    }
    let d = "";
    for (let k = 0; k < punkte.length; k++) {
      const lon = punkte[k][0], lat = punkte[k][1];
      d += (k === 0 ? "M" : "L") + (lon + 180).toFixed(2) + " " + (90 - lat).toFixed(2);
    }
    return d + "Z";
  };
  const pfade = [];
  for (const g of obj.geometries) {
    if (g.type === "Polygon") pfade.push(g.arcs.map(ringPfad).join(" "));
    else if (g.type === "MultiPolygon") pfade.push(g.arcs.map((poly) => poly.map(ringPfad).join(" ")).join(" "));
  }
  return pfade;
}

function ladeWeltkarte() {
  if (weltkarteCache) return Promise.resolve(weltkarteCache);
  if (weltkartePromise) return weltkartePromise;
  weltkartePromise = fetch(WELTKARTE_CDN)
    .then((r) => { if (!r.ok) throw new Error("Karte nicht ladbar"); return r.json(); })
    .then((topo) => { weltkarteCache = topoZuPfade(topo); return weltkarteCache; })
    .catch((e) => { weltkartePromise = null; throw e; });
  return weltkartePromise;
}

export { WELTKARTE_CDN, kellerNachRegion, ladeWeltkarte, topoZuPfade, weltkarteCache, weltkartePromise };
